export enum LoanPurpose {
  SwimmingPool = 'Swimming Pool',
  SpaHotTub = 'Spa / Hot Tub',
  Deck = 'Deck',
  Kitchen = 'Kitchen',
  Bathroom = 'Bathroom',
  RoofingSiding = 'Roofing / Siding',
  Solar = 'Solar',
  Landscaping = 'Landscaping / Hardscaping',
  HomeAddition = 'Home Addition',
  PoleBarn = 'Pole Barn',
  MetalBuilding = 'Metal Building',
  ADU = 'ADU - Detached',
  OtherHomeImprovement = 'Other Home Improvement(s)',
}
